import { useSettings } from "@app-composables/settings";
import useAppStore from "@app-store/app";
import useLangStore from "@app-store/lang";
import { createRestClient } from "scarlett";
export interface IResponseAny {
	<TData = any, TError = any>(prom: Promise<any>): Promise<
		[TData | null, TError | null]
	>;
}

export type ErrorCode<T = string> = T
export interface IResponseError<T = string> {
	Error?: {
		Code: ErrorCode<T>,
		Message: string
	}
}
export interface IRestResponse<T> {
	Elements: T[],
	HasMoreElements: boolean
}
export const CUSTOM_BACKEND_URL_STORAGE_KEY = "customBackendUrl";

export const resolveAny: IResponseAny = (prom: Promise<any>) => {
	return new Promise<any>(resolve => {
		prom.then((response: any) =>
			resolve([response, null])
		).catch((err: any) => resolve([null, err]));
	});
};

export function defineCloudBackend() {
	const { cloudBackendUrl, apiSubscriptionKey } = useSettings();

	const baseClient = createRestClient({
		basePath: "/bowler",
		throw: true,
		headers: new Headers({
			Pragma: "no-cache",
			"Cache-Control": "no-cache, no-store",
			"Content-Type": "application/json",
			"Ocp-Apim-Subscription-Key": apiSubscriptionKey.value
		}),
		credentials: "omit",
		responseType: (req, res) => {
			if (res?.status === 500)
				return "text";

			return "json";
		},
		// FIXME: Remove this filter when every request failure is handled (via specific status codes and error codes)
		throwExcluding: [{ errorCode: "BodyParse" }],
		onRequest: function(req) {
			const appStore = useAppStore();
			if (!req.options.headers)
				req.options.headers = new Headers();
			const headers = req.options.headers;

			const language = useLangStore().isoCode;
			if (language)
				headers.set("Accept-Language", language);

			const token = appStore.isAccessTokenValid() ? appStore.accessToken : null;
			if (!token)
				headers.delete("Authorization");
			else
				headers.set("Authorization", `Bearer ${token}`);
		}
	})();

	const customBackendUrl = sessionStorage.getItem(CUSTOM_BACKEND_URL_STORAGE_KEY);
	const host = customBackendUrl ?? (window as any).__BACKEND_URL__ ?? cloudBackendUrl.value;

	baseClient.setOption("host", host);

	return () => baseClient;
}
